import RightNavigationBar from '../components/createProject/RightNavigationBar'
import ProjectBasicDetails from '../components/createProject/ProjectBasicDetails'
import Header from '../components/global/Header'
import { useRef } from 'react'
import LeftNavbar from '../components/global/LeftNavbar'
import { useParams, Link, useNavigate } from 'react-router-dom';
import {  useTranslation } from 'react-i18next';
import { ProjectFooter } from '../components/createProject/ProjectFooter'
import { dateConvertToTimeStamp, FILE_TYPE_PREF, getFileExtension, isXLIFFExtractionEnabled } from '../services/Util'
import { getAxiosResponse, postAxiosResponse, handleError } from '../services/authApiRoutes/APImethods'
import APIUrls from '../services/APIUrls'
import Constants from "../Constants";
import { ProjectTranslate } from '../components/createProject/ProjectTranslate'
import LangaugeReferenceMaterial from '../components/createProject/LangaugeReferenceMaterial'
import { transformBlankToNull } from '../services/Util';
import {  useDispatch, useSelector } from "react-redux";
import { projectCreationStepFilter } from '../redux/reducers/ProjectCreationStepSlice';
import {updateProjectInfo } from '../redux/reducers/ProjectInfoSlice';
import ProjectSummary from '../components/createProject/ProjectSummary';
import SelectAssetType from "../components/createProject/SelectAssetType"
import UploadFile from "../components/createProject/UploadFile"
import Workflow from '../components/createProject/Workflow'
import SelectWorkflow from '../components/createProject/SelectWorkflow'
import WorkflowAndFollowers from '../components/createProject/WorkflowAndFollowers'
import DynamicAssets from '../components/createProject/DynamicAssets'
import StaticAssets from '../components/createProject/StaticAssets'
import React, { useEffect, useState } from 'react'
import MarketoRestIntegration from '../components/createProject/MarketoRestIntegration'
import EloquaIntegration from '../components/createProject/EloquaIntegration'
import BrightcoveIntegration from '../components/createProject/BrightcoveIntegration'
import PardotIntegration from '../components/createProject/PardotIntegration'
import VidyardIntegration from '../components/createProject/VidyardIntegration'
import UberflipIntegration from '../components/createProject/UberflipIntegration';
import ExactTargetIntegration from '../components/createProject/ExactTargetIntegration';
import EloquaImageUpload from "../components/createProject/EloquaImageUpload";
import { updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors } from '../redux/reducers/AsyncAssetUploadSlice';
import { TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import "@reactour/popover/dist/index.css";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import { updateAsyncUploadAssetPendingFiles,updateAsyncUploadAssetCompletedFiles,updateAsyncUploadAssetInProgressFiles } from '../redux/reducers/AsyncAssetUploadSlice';
import { updateContentType } from '../redux/reducers/CreateProjectContentTypeSlice';
// import steps from "../services/tourJson/create-project";
import $ from "jquery";
import AppErrorPage from './AppErrorPage';
import { updateCustomerBootstrapData } from '../redux/reducers/CustomerBootstrapDataSlice';
import { getSelectedAssetKeys, isSegmentationModeEnabled } from '../services/IntegrationUtil'
import { updateWidthChanges } from "../redux/reducers/TreeSlice";

const ProjectTranslateMemo = React.memo(ProjectTranslate);
const ProjectBasicDetailsMemo = React.memo(ProjectBasicDetails);                    
const LangaugeReferenceMaterialMemo = React.memo(LangaugeReferenceMaterial);
const WorkflowMemo = React.memo(Workflow);
const SelectWorkflowMemo = React.memo(SelectWorkflow);
const WorkflowAndFollowersMemo = React.memo(WorkflowAndFollowers);
const ProjectSummaryMemo = React.memo(ProjectSummary);
const UploadFileMemo = React.memo(UploadFile);
const MarketoRestIntegrationMemo = React.memo(MarketoRestIntegration);
const EloquaIntegrationMemo = React.memo(EloquaIntegration);
const BrightcoveIntegrationMemo = React.memo(BrightcoveIntegration);
const SelectAssetTypeMemo = React.memo(SelectAssetType);
const DynamicAssetsMemo = React.memo(DynamicAssets)
const StaticAssetsMemo = React.memo(StaticAssets)
const PardotIntegrationMemo = React.memo(PardotIntegration)
const VidyardIntegrationMemo = React.memo(VidyardIntegration);
const UberflipIntegrationMemo = React.memo(UberflipIntegration)
const ExactTargetIntegrationMemo = React.memo(ExactTargetIntegration)
const EloquaImageUploadMemo = React.memo(EloquaImageUpload);


export default function CreateProject(props) {
  const params = useParams()
  const scrollRef = useRef(null);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translate = t;
  const [showNotification, setShowNotification] = useState(false);
  const projectCreationSteps = ["Source Material Step 1",
	"Source Material Step 2",
	"Upload Image Step",
	"Language and Reference Material",
	"Project Information",
	"Translation Request",
	"Workflow Step 1",
	"Workflow Step 2",
	"Project Summary",
	"Finish And Request Translation"];

  const [style, setStyle]=useState([]);
  const [errorStatus,setErrorStatus]=useState(true);

  const projectConfigurationStatus = [
    'configured_project_name',
    'uploaded_source_materials',
    'configured_bid_options',
    'configured_project_workflow','configured_project_details'
  ]

  const navigate=useNavigate()
  const projectCreationStep= useSelector(
    (projectCreationStepSlice) => projectCreationStepSlice.project_creation_step
  ).value;
  const projectContentType = useSelector(
    (CreateProjectContentTypeSlice) => CreateProjectContentTypeSlice.content_type_for_project_creation
  ).value;
  
  const projectAssetType = useSelector(redux => redux.asset_type_for_project_creation).value;
  const hasValidationRun = useRef(false);
  const asyncAssetUploadInfo = useSelector(reduxStore => reduxStore.asset_upload_background).value;
  const customerBootstrapData = useSelector((redux) => redux.customer_bootstrap_data).value;
  const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
  const projectRules = useSelector(reduxStore => reduxStore.dynamic_asset).projectRules;
  const selectedTreeData = useSelector(reduxStore => reduxStore.tree_structure).selectedTreeData;
  const sourceLanguageRedux = useSelector((reduxStore) => reduxStore.source_language_for_project_creation).value;

  const segmentationFeatureCheck = () => {
		const isSegModeEnabled = projectContentType === Constants.MARKETOREST ? customerBootstrapData?.features?.MARKETO_REST_SEGMENTATION_MODE :
      projectContentType === Constants.ELOQUA ? customerBootstrapData?.features?.ELOQUA_DYNAMIC_CONTENT : false;
		return isSegModeEnabled;
	}

  const handleValidation = async () => {
    try {
      let response;
  
      if (projectContentType === "STANDARD") {
        const sourceAssetsResponse = await getAxiosResponse(APIUrls.GET_SOURCE_ASSETS(params.id));
  
        if (sourceAssetsResponse.data !== "") {
          const sourceAssets = sourceAssetsResponse.data.data.result;
  
          const projectResponse = await getAxiosResponse(APIUrls.PROJECT(params.id));
          const project = projectResponse.data.data.resource.projectResource;
  
          const assetsToBeValidated = sourceAssets.map((sourceAsset) => {
            const asset = sourceAsset.assets[0];
            let isVideoProject = asset.name.endsWith(".mp4");
            var assetName = asset.name;
            if(isVideoProject) {
                assetName = sourceAsset?.files["INTERMEDIATE"]?.documentFile?.filename;
            }
            return {
              name: assetName,
              externalId: sourceAsset?.files["FINAL"]?.documentFile?.id,
              assetType: asset.assetType.compType,
              contentType: asset.contentType,
              includeDependencies: false,
              sourceLanguage: project.sourceLanguage,
              targetLanguages: project.targetLanguages,
            };
          });
  
          response = await postAxiosResponse(APIUrls.VALIDATE_ASSET(params.id), { "validateAssets": assetsToBeValidated });
        }
      } else if (projectContentType === "MARKETOREST" || projectContentType === "ELOQUA") {
        const dynamicContentEnabled = segmentationFeatureCheck();
        const isClone = projectData?.clonedFromProjectId !== null;
  
        const assetsToBeValidated = getSelectedAssetKeys(
          selectedTreeData,
          projectRules,
          sourceLanguageRedux.language,
          projectContentType,
          isSegmentationModeEnabled(dynamicContentEnabled, projectRules),
          isClone
        );
  
        response = await postAxiosResponse(APIUrls.VALIDATE_ASSET(params.id), { "validateAssets": assetsToBeValidated });
      }
  
      if (response && response.data.code === 200) {
        dispatch(updateReadyForValidation(false));
        dispatch(updateValidationErrors(response.data.data.body));
  
        const validationErrors = response.data.data.body.find((validation) => validation.error !== "");
        const isEloqua = projectContentType === Constants.ELOQUA;
  
        if (validationErrors === undefined) {
          dispatch(updateCanSubmitTranslation(true));
        } else {
          const validatedAssets = response.data.data.body;
  
          const isAllAssetsPass = validatedAssets.every(asset => asset.status !== Constants.ERROR);
					dispatch(updateCanSubmitTranslation(isEloqua ? true : isAllAssetsPass));

        }
      }
    } catch (error) {
      console.error("Error during validation : ", error);
    }
  };
  
  const executeAssetValidation = async () => {
    if (asyncAssetUploadInfo.isReadyForValidation && customerBootstrapData?.features?.ASSET_VALIDATION) {
      if (projectCreationSteps.indexOf(projectCreationStep) >= 4) {
        await handleValidation();
      }
    }
  }

  useEffect(() => {
    if ( !hasValidationRun.current && sourceLanguageRedux?.language !== '' && projectData.targetLanguages?.length !== 0 && selectedTreeData?.length !== 0) {
      handleValidation();
      hasValidationRun.current = true;
    }
  }, [projectCreationSteps.indexOf(projectCreationStep) === 3]);

  executeAssetValidation();

  const getProjectInfoById = async () => {let projectResource=null
    let result = await getAxiosResponse(APIUrls.PROJECT(params.id))
    result=transformBlankToNull(result);
    let error=result?.data?.error
    if(error){
      setErrorStatus(false)
    return 
    }else{
      projectResource = result?.data?.data?.resource?.projectResource;
    }
    delete projectResource["projectFollowers"];
    //deleted  this key as it was giving 400 
    if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
      delete projectResource["workspace"]['workspaceMembers']
    }
    projectResource.intendedUse = {"id":projectResource?.intendedUse?.id,"name":projectResource?.intendedUse?.name};
      if(!projectResource?.intendedUse?.id && projectResource?.projectRequest?.id)
        {
          let intendedUseId = await getIntendedUseForProjectCreation();
          projectResource.intendedUse.id = intendedUseId;
        }
    projectResource.targetLanguageList = result.data.data.displayName[0].targetLanguages;
    if(projectResource?.projectRequest === Constants.BLANK) {
      dispatch(updateContentType(null));
    }
    if(!projectConfigurationStatus.includes(result?.data?.data?.resource?.projectResource?.status?.code)){
      navigate(`/project/${result?.data?.data?.resource?.projectResource?.id}`)
     }
    dispatch(updateProjectInfo(projectResource));
  }

const getIntendedUseForProjectCreation = async() =>{
    const result = await getAxiosResponse(APIUrls.INTENDED_USES_TASKS).then((res) => {
      if (res.data.code === 200) {
        const minimumIntendedUseId = Math.max(...res.data.data.map(x=>x.id))
       return minimumIntendedUseId;
      }
     }).catch(err=>{
      console.error(err)
    })
    return result;
  };

  const getDepartmentPreferences = () => {
    Promise.all([getAxiosResponse(APIUrls.ALL_DEPARTMENT), getAxiosResponse(APIUrls.CUSTOMER_DEPARTMENNT_PREFRENCE),
    ]).then(async ([allDepartmentResponse, preferDepartmentResp]) => {
    if(allDepartmentResponse.data.code === 200){
      let arr=[]
      allDepartmentResponse.data.data.forEach((data)=>{    
      for (const key in preferDepartmentResp?.data?.data) {
        if (Object.hasOwnProperty.call(preferDepartmentResp?.data?.data, key)) {
        const value = preferDepartmentResp?.data?.data[key];
        if(+key === +data.id){
          let prefrence=[];
          value.forEach(d=>{
          if(d.status==="true"){
            if(FILE_TYPE_PREF[d.preference]){
            prefrence.push(FILE_TYPE_PREF[d.preference])
            }
          }
          });
          let obj={id:data.id,name:data.name,prefrence:prefrence,status:true}
         arr.push(obj)
        }
        }
      } 
      })
      dispatch(updateCustomerBootstrapData({ type: "userGroupOneReviewPreferences", value: arr}))
    }
    }).catch((err) => {
    handleError(err);
    })
  }

  useEffect(() => {
    getProjectInfoById();    
    getDepartmentPreferences();
    dispatch(updateWidthChanges(null));
  }, [])

  useEffect(() => {
    if ((asyncAssetUploadInfo?.pendingFiles && Object.keys(asyncAssetUploadInfo?.pendingFiles)?.length === 0) && asyncAssetUploadInfo?.completedFiles?.length !== 0
    ) {
      setShowNotification(true);
      const timeoutId = setTimeout(() => {
        setShowNotification(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }
  }, [asyncAssetUploadInfo?.pendingFiles, asyncAssetUploadInfo?.completedFiles, asyncAssetUploadInfo?.isReadyForValidation]);

  const viewFiles = ()=>{  
    dispatch(projectCreationStepFilter("Source Material Step 2"));
  };

//Tutorial Tips start
function doArrow(position, verticalAlign, horizontalAlign) {
  if (!position) {
    return {};
  }
 const width = 16;
  const height = 12;
  const color = "white";
  const isVertical = position === "top" || position === "bottom";
  const spaceFromSide = 10;


  


  const obj = {
    [`--rtp-arrow-${
      isVertical ? opositeSide[horizontalAlign] : verticalAlign
    }`]: height + spaceFromSide + "px",
    [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
    [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`
  };
  return obj;
}
const styles = {
  popover: (base, state) => {
   return {
      ...base,
     ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
     '--reactour-accent': '#154da1',
     };
  }
  
};
const opositeSide = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
const disableBody = (target) => disableBodyScroll(target)
const enableBody = (target) => enableBodyScroll(target)
const CreateModelTutorial = () =>{
 document.body.classList.add("modal-open-6");
 $(".nextFocus6").on("keydown", function (e) {
  if (e.key === Constants.TAB) {
    if (e.shiftKey === false) {
      e.preventDefault();
      $(".cancelFocus6").trigger("focus");
    }
  }
});
setTimeout(() => {
  $(".cancelFocus6").trigger("focus");
  $(".cancelFocus6").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === true) {
        e.preventDefault();
        $(".nextFocus6").trigger("focus");
      }
    }
  });
  $(".inner-lightbox-panel").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      document.body.classList.remove("modal-open-6");
      $('.focusAdd').trigger('focus');
      $('.tutorial-tips').removeClass('focusAdd');
    }
  });
}, 500);
 
}
const [toggle, setToggle]=useState(true)
var tourCreationStep = useSelector(
  (tourStep) => tourStep.tour_steps
).value;
useEffect(()=>{
 // setToggle(false)
  setTimeout(()=>{
    setStyle(tourCreationStep)
    setToggle(false)
  },2000)
  
  
},[tourCreationStep])

//Tutorial Tips end
const crumbs = [{label:'Create project', url:''}];

function renderUploadStatus() {
  if(customerBootstrapData?.features?.ASSET_VALIDATION && asyncAssetUploadInfo.validationErrors.length !== 0) {
    return <span>File upload and validation completed.</span>;
  } else {
    return <span>File upload completed.</span>;
  }
}

  return (
    <div className="body bg-color">
       {errorStatus? 
      <div id="container" className="dashboard-wrapper tourslider-dots">
      <TourProvider
          steps={tourCreationStep}
          styles={style}
          afterOpen={disableBody}
          beforeClose={enableBody}
          showDots={false}
          onClickMask={({ currentStep, steps, setIsOpen }) => {
            if (steps) {
              if (currentStep === steps.length) {
                setIsOpen(toggle);
               }
              }
          }}
          badgeContent={({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps}
          >
          <Header statusBar func={CreateModelTutorial} ref={scrollRef}/>
           <LeftNavbar />
         </TourProvider>
        <section className="dashboard-content create-project-content" ref={scrollRef}>
          <div id="content" className="dashboard-wrap">
            <Breadcrumb crumbs={ crumbs } />
           {errorStatus? <RightNavigationBar />:Constants.BLANK}
            <div className="create-project-section" >
              <div className="flex">
                <div className="white-bg">
                <div className={showNotification ? "success-message" : "success-message hide"}>
                    {renderUploadStatus()}
                    <button className="cross" onClick={() => setShowNotification(false)} aria-label="close">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                          <path d="M6.57812 6.90625L13.048 13.0938M13.048 6.90625L6.57812 13.0938L13.048 6.90625Z" stroke="#2A4274" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
						              <path d="M9.81402 18.5938C14.7768 18.5938 18.7999 14.7462 18.7999 10C18.7999 5.2538 14.7768 1.40625 9.81402 1.40625C4.85125 1.40625 0.828125 5.2538 0.828125 10C0.828125 14.7462 4.85125 18.5938 9.81402 18.5938Z" stroke="#2A4274" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                        </svg>
                    </button>
                </div>

                  <div className="step-1-section">
                    <>
                    <div>
                      {projectCreationStep === "Project Information" &&
                        <ProjectBasicDetailsMemo  />  
                      }
                      {projectCreationStep === "Translation Request" &&
                        <ProjectTranslateMemo  />  
                      }
                    </div>
                    <div className={projectCreationStep==="Source Material Step 1"?"show":"hide"}>
                    <SelectAssetTypeMemo  />
                    </div>
                    <div>
                    {projectCreationStep === Constants.SOURCE_MATERIAL_STEP_2
                      ? (() => {
                          switch (projectContentType) {
                            case Constants.STANDARD:
                              return <UploadFileMemo />;
                            case Constants.MARKETOREST:
                              return <MarketoRestIntegrationMemo />;
                            case Constants.ELOQUA:
                              return <EloquaIntegrationMemo />;
                            case Constants.BRIGHTCOVE:
                              return <BrightcoveIntegrationMemo />;
                            case Constants.PARDOT:
                              return <PardotIntegrationMemo />;
                            case Constants.VIDYARD:
                              return <VidyardIntegrationMemo />;
                            case Constants.UBERFLIP:
                              return <UberflipIntegrationMemo />;
                            case Constants.EXACTTARGET:
                              return <ExactTargetIntegrationMemo />;
                            default:
                              return <UploadFileMemo />;
                          }
                        })()
                      : ("")
                    }
                    </div>
                    <div>
                      {projectCreationStep === Constants.UPLOAD_IMAGE_STEP && <EloquaImageUploadMemo />}
                      {projectCreationStep === Constants.LANGUAGE_AND_REFERENCE_MATERIAL && 
                        (projectContentType === Constants.MARKETOREST || projectContentType === Constants.ELOQUA || projectContentType === Constants.BRIGHTCOVE || 
                          projectContentType === Constants.PARDOT || projectContentType === Constants.VIDYARD || projectContentType === Constants.UBERFLIP || projectContentType === Constants.EXACTTARGET ?
                          projectAssetType === Constants.DYNAMIC ?
                            (<DynamicAssetsMemo />)
                          : (<StaticAssetsMemo />)
                        : (<LangaugeReferenceMaterialMemo/>)
                        )
                      }
                    </div>
                    {projectCreationStep === "Workflow Step 1" && <WorkflowAndFollowersMemo/>}
                    {projectCreationStep === "Workflow Step 2" && <SelectWorkflowMemo/>}
                    {projectCreationStep==="Project Summary" && <ProjectSummaryMemo />}
                    </>
                  </div>
                
                </div>
              </div>
                <ProjectFooter/>
            </div>
          </div>
        </section>
      </div>:<AppErrorPage errorMsg={translate("project_error_msg")} ></AppErrorPage>}
    </div>
  );
}
